var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{style:({backgroundColor: 'rgba(255, 255, 255, ' + _vm.RGBA + ')'}),attrs:{"id":"mainnav"}},[_c('NavBar')],1),_c('router-view'),_c('div',{attrs:{"id":"footer"}},[_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }